import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { TherapeuticGroupStatus } from '@dreryk/egabinet-group-session-frontend-api';

import { MessageOptions } from '@dreryk/react-components';

export const useOptions = (): MessageOptions<Record<TherapeuticGroupStatus, string>> => {
   const theme = useTheme();
   const configuration = useMemo(
      () => ({
         DRAFT: {
            color: theme.primary,
            backgroundColor: theme.primaryLighter,
         },
         READY: {
            color: theme.warning,
            backgroundColor: theme.warningLighter,
         },
         ACTIVE: {
            color: theme.info,
            backgroundColor: theme.infoLighter,
         },
         COMPLETED: {
            color: theme.success,
            backgroundColor: theme.successLighter,
         },
         CANCELLED: {
            color: theme.error,
            backgroundColor: theme.errorLighter,
         },
      }),
      [theme]
   );

   return configuration;
};
